import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./Routes/routes";
import ReactGA from "react-ga4";
import { useEffect } from "react";

function App() {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

  useEffect(() => {
    ReactGA.send("pageview");
  }, []);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
